import * as https from "./https";
import * as admin from "./admin";
import * as route from "./route";
import * as hotels from "./hotels";
import * as places from "./places";
import * as members from "./members";
import * as firestore from "./firestore";
import * as curveRoads from "./curve-roads";
import * as graphhopper from "./graphhopper";
import * as customPlaces from "./places/custom";

import { tags } from "./tags";

export const api = {
  tags,
  https,
  admin,
  route,
  hotels,
  places,
  members,
  firestore,
  curveRoads,
  graphhopper,
  customPlaces,
};
